import { Injectable } from '@angular/core';
import { ProjectTemplateCoreService } from './project-template-core.service';
import { ApiService } from '../../api/api.service';
import { TemplateService } from '../../utilities/template/template.service';
import { ApiLegacyService } from '../../api/legacy/api-legacy.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectTemplateService extends ProjectTemplateCoreService {

  constructor(
    protected apiService: ApiService,
    protected apiLegacyService: ApiLegacyService,
    protected templateService: TemplateService
  ) {
    super(apiService, apiLegacyService, templateService);
  }
}
